import { IBuyPackageService } from '../../../../../../../types/packages';

export const getIsAuctionPointsColAvailable = (services: Array<IBuyPackageService>): boolean => {
  return services.some(service => !!service.auctionPoints);
};
